<template>
    <div class="feature-count-down">
        <!-- countdown: {{ countDown }} -->
        <template v-if="featureMatchTimer[o.matchId]">
            {{ featureMatchTimer[o.matchId].remainingTime }}
        </template>
    </div>
</template>

<script>
    export default {
        name: 'FeatureMatchCountDown',
        data() {
            return {
                firstTime: true,
            }
        },
        computed: {
            countDown() {
                if(this.o.remainingTime) {
                    return this.o.remainingTime
                }

            }
        },
        props: {
            o: Object,
            featureMatchTimer: Object
        },
        mounted() {  
            // this.countdownToTime(this.o.matchTime, this.o)
        },
        methods: {
            // countdownToTime(targetTimeString, o) {
            //     const targetTime = new Date(targetTimeString).getTime();
            //     const now = new Date().getTime();

            //     // 如果目标时间已经过去，直接返回
            //     if (targetTime <= now) {
            //         this.$emit('countdownFinished', "Time reached!");
            //         return "Time reached!";
            //     }

            //     // 计算初始剩余时间
            //     let remainingTime = Math.floor((targetTime - now) / 1000);
            //     // 每秒更新倒计时
            //     const interval = setInterval(() => {
            //         const currentTime = new Date().getTime();
            //         remainingTime = Math.floor((targetTime - currentTime) / 1000);

            //         if (remainingTime <= 0) {
            //             clearInterval(interval);
            //             delete this.o['remainingTime']
            //         } else {
                        
            //             this.o['remainingTime'] = this.initTimeFormat(remainingTime)
            //         }
            //     }, 1000);
            //     // return o['remainingTime'];
            // },
            // initTimeFormat(seconds) {
            //     const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
            //     const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
            //     const secs = String(seconds % 60).padStart(2, '0');
            //     return `${hours}:${minutes}:${secs}`;
            // }
        }
    }
</script>

<style scoped>
.feature-count-down {
    color: var(--color-text-default-secondary);
    letter-spacing: .24px;
    font-family: var(--weight-700);
    min-height: 15.59px;
}
</style>

